export const BEAUTY_GENIUS_TYPE_IN_TAGGING_EVENT = 'beauty-genius-type-in-tagging';
export const BEAUTY_GENIUS_NAME_ASK_QUESTION = 'askQuestion';
export const BEAUTY_GENIUS_NAME_HIDE = 'hideIframe';
export const BEAUTY_GENIUS_NAME_SHOW = 'showIframe';
